module.exports = __webpack_public_path__ + "static/media/9_file_import_requirements_and_best_practices.79ab1704.png";